import { Checkbox, FileUpload } from '@consigli/facade';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CompareConfig } from './types';

interface BidVsBidControlsProps {
  config: CompareConfig;
  onChange: (config: CompareConfig) => void;
}

export const BidVsBidControls: FC<BidVsBidControlsProps> = ({ config, onChange }) => {
  const { t } = useTranslation();
  const [showLevelingPanel, setShowLevelingPanel] = useState(true);

  const setLevelingSheetFiles: Dispatch<SetStateAction<File[]>> = (value) => {
    const nextFiles = typeof value === 'function' ? value(config.levelingSheetFiles) : value;
    onChange({ ...config, levelingSheetFiles: nextFiles });
  };

  return (
    <div className="w-full rounded-lg border border-day-light-2 bg-day-light-5 p-6">
      <h3 className="mb-4 text-lg font-semibold text-day-neutral-dark">
        {t('bid-review.compare.bid-vs-bid-title')}
      </h3>

      <p className="mt-4 text-sm font-semibold text-day-neutral-subtle">
        {t('bid-review.compare.leveling-sheet-note')}
      </p>

      <div className="mt-4 rounded-lg border border-day-light-2 p-4">
        <div className="flex items-start gap-3">
          <Checkbox
            id="auto-fill-leveling-sheet"
            ariaLabel={t('bid-review.compare.auto-fill-leveling-sheet')}
            checked={config.autoFillLevelingSheet}
            onChange={() =>
              onChange({ ...config, autoFillLevelingSheet: !config.autoFillLevelingSheet })
            }
          />
          <label htmlFor="auto-fill-leveling-sheet" className="flex cursor-pointer flex-col">
            <span className="font-semibold text-day-neutral-dark">
              {t('bid-review.compare.auto-fill-leveling-sheet')}
            </span>
            <span className="mt-0.5 text-sm text-day-neutral-subtle">
              {t('bid-review.compare.auto-fill-leveling-sheet-description')}
            </span>
          </label>
        </div>

        {config.autoFillLevelingSheet && (
          <div className="mt-4">
            <FileUpload
              files={config.levelingSheetFiles}
              setFiles={setLevelingSheetFiles}
              dropAreaLabel={t('bid-review.compare.leveling-sheet-upload-label')}
              dropAreaClassName="mt-1 h-40 w-full"
              fileButtonLabel={t('document-upload.browse-files')}
              folderButtonLabel={t('document-upload.browse-folders')}
              uploadListLabel={t('document-upload.files')}
              zeroByteFilesMessage={t('document-upload.file-zero-bytes')}
              showMessagePanel={showLevelingPanel}
              setShowMessagePanel={setShowLevelingPanel}
            />
          </div>
        )}
      </div>
    </div>
  );
};
